// extracted by mini-css-extract-plugin
module.exports = {"Container":"Map_Container__3GOTR","Search":"Map_Search__2x6tG","Suggestions":"Map_Suggestions__1qJjl"};